module.exports = __webpack_public_path__ + "static/media/office2.b57d6529.jpg";